export const CALENDAR_VIEW_RELIEVE_DAY_NEXT_FREE_DAY_FAILED = {
  date: null,
  isFailed: true,
}
